/**
 * @file Remember that Scan Mode used the camera so Scan Items can auto-open it.
 */

const AUTO_OPEN_SCAN_CAMERA_KEY = 'eb.autoOpenScanCamera';

/** Mark that the next bidder scan page should try to auto-open the camera. */
export function setAutoOpenScanCamera() {
  try {
    sessionStorage.setItem(AUTO_OPEN_SCAN_CAMERA_KEY, '1');
  } catch {
    // Ignore quota / private-mode failures
  }
}

/**
 * Read and clear the auto-open flag.
 * @returns {boolean}
 */
export function consumeAutoOpenScanCamera() {
  try {
    const flagged = sessionStorage.getItem(AUTO_OPEN_SCAN_CAMERA_KEY) === '1';
    sessionStorage.removeItem(AUTO_OPEN_SCAN_CAMERA_KEY);
    return flagged;
  } catch {
    return false;
  }
}
